import { render, staticRenderFns } from "./recipe-list-summary-item.vue?vue&type=template&id=c083209c&"
import script from "./recipe-list-summary-item.vue?vue&type=script&lang=js&"
export * from "./recipe-list-summary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports